import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Sun, Moon, Palette } from "lucide-react";

export type Theme = 'default' | 'dark' | 'light-simple';

interface ThemeToggleProps {
  theme: Theme;
  onThemeChange: (theme: Theme) => void;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme, onThemeChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Select value={theme} onValueChange={(value) => onThemeChange(value as Theme)}>
        <SelectTrigger className="w-[140px] bg-background border-border rounded-xl h-9 text-xs font-bold shadow-sm transition-colors duration-300">
          <SelectValue placeholder="테마 선택" />
        </SelectTrigger>
        <SelectContent className="rounded-xl border-slate-200 dark:border-slate-800 shadow-xl">
          <SelectItem value="default" className="text-xs font-bold cursor-pointer transition-colors focus:bg-slate-100 dark:focus:bg-slate-800">
            <div className="flex items-center gap-2">
              <Sun className="w-3.5 h-3.5 text-amber-500" />
              <span>기본 (Color)</span>
            </div>
          </SelectItem>
          <SelectItem value="dark" className="text-xs font-bold cursor-pointer transition-colors focus:bg-slate-100 dark:focus:bg-slate-800">
            <div className="flex items-center gap-2">
              <Moon className="w-3.5 h-3.5 text-blue-400" />
              <span>다크 (Dark)</span>
            </div>
          </SelectItem>
          <SelectItem value="light-simple" className="text-xs font-bold cursor-pointer transition-colors focus:bg-slate-100 dark:focus:bg-slate-800">
            <div className="flex items-center gap-2">
              <Palette className="w-3.5 h-3.5 text-slate-500" />
              <span>심플 (Gray)</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
